import { differenceInDays, isBefore } from 'date-fns';

import type { PaymentCard } from '@MP/shared/api/hooks/payhub';
import DateUtils, { DateType } from '@MP/shared/utils/DateUtils';

export enum CardStatus {
  NORMAL,
  EXPIRED,
  EXPIRING_SOON,
}
const CardStatusUtils = {
  toStatus: (info: PaymentCard) => {
    const now = new Date();
    const expire = DateUtils.parse(info.cardExpireAt, DateType.ZonedDateTime);
    // 만료 시각이 이미 지났으면 EXPIRED. differenceInDays는 24시간 미만 차이를 0으로 절삭하므로
    // 잔여 일수만으로 판단하면 하루 내에 만료된 카드를 놓친다.
    if (isBefore(expire, now)) {
      return CardStatus.EXPIRED;
    }
    // 정확히 30일 남은 경우까지 "만료 임박"으로 포함해 30일 알림 분기를 도달 가능하게 한다.
    if (differenceInDays(expire, now) <= 30) {
      return CardStatus.EXPIRING_SOON;
    }
    return CardStatus.NORMAL;
  },
  toRemainingDay: (info: PaymentCard) => {
    const now = new Date();
    const expire = DateUtils.parse(info.cardExpireAt, DateType.ZonedDateTime);
    return differenceInDays(expire, now);
  },

  isExpired: (info: PaymentCard) => {
    return CardStatusUtils.toStatus(info) === CardStatus.EXPIRED;
  },
};
export default CardStatusUtils;
